module.exports = __webpack_public_path__ + "static/media/heart.dd24f9fe.svg";